"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIE_COMPONENT_TYPE_TO_UNITS = exports.TIE_COMPONENT_TYPE_TO_CHARACTERISTIC = exports.TIE_COMPONENT_TYPE_TO_MODEL = exports.MODEL_TO_TIE_COMPONENT_TYPE = exports.flatSignalTieSchema = exports.flatSignalTieComponentValueSchema = exports.flatSignalTieComponentValueRangeSchema = exports.flatSignalTieComponentValueAbsoluteSchema = exports.SignalTiePolarity = exports.SignalTieVarianceType = exports.SignalTieComponentType = exports.SignalTieConnectionType = void 0;
exports.isPolarizedTieComponentType = isPolarizedTieComponentType;
exports.reverseSignalTiePolarity = reverseSignalTiePolarity;
const zod_1 = require("zod");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
var SignalTieConnectionType;
(function (SignalTieConnectionType) {
    SignalTieConnectionType["Direct"] = "direct";
    SignalTieConnectionType["ThroughComponent"] = "throughComponent";
})(SignalTieConnectionType || (exports.SignalTieConnectionType = SignalTieConnectionType = {}));
var SignalTieComponentType;
(function (SignalTieComponentType) {
    SignalTieComponentType["Capacitor"] = "capacitor";
    SignalTieComponentType["CapacitorPolarized"] = "capacitorPolarized";
    SignalTieComponentType["Inductor"] = "inductor";
    SignalTieComponentType["Resistor"] = "resistor";
})(SignalTieComponentType || (exports.SignalTieComponentType = SignalTieComponentType = {}));
var SignalTieVarianceType;
(function (SignalTieVarianceType) {
    SignalTieVarianceType["Absolute"] = "absolute";
    SignalTieVarianceType["Relative"] = "relative";
})(SignalTieVarianceType || (exports.SignalTieVarianceType = SignalTieVarianceType = {}));
var SignalTiePolarity;
(function (SignalTiePolarity) {
    SignalTiePolarity["PositiveOnSignal"] = "positive_on_signal";
    SignalTiePolarity["PositiveOnTarget"] = "positive_on_target";
})(SignalTiePolarity || (exports.SignalTiePolarity = SignalTiePolarity = {}));
exports.flatSignalTieComponentValueAbsoluteSchema = zod_1.z.object({
    type: zod_1.z.literal('absolute'),
    value: zod_1.z.number(),
    variance: zod_1.z.number().nullable(),
    varianceType: zod_1.z.nativeEnum(SignalTieVarianceType).nullable(),
});
exports.flatSignalTieComponentValueRangeSchema = zod_1.z.object({
    type: zod_1.z.literal('range'),
    min: zod_1.z.number().nullable(),
    max: zod_1.z.number().nullable(),
});
exports.flatSignalTieComponentValueSchema = zod_1.z.discriminatedUnion('type', [
    exports.flatSignalTieComponentValueAbsoluteSchema,
    exports.flatSignalTieComponentValueRangeSchema,
]);
exports.flatSignalTieSchema = zod_1.z.object({
    toSignalId: zod_1.z.string(),
    connectionType: zod_1.z.nativeEnum(SignalTieConnectionType),
    componentType: zod_1.z.nativeEnum(SignalTieComponentType).nullable(),
    componentValue: exports.flatSignalTieComponentValueSchema.nullable(),
    polarity: zod_1.z.nativeEnum(SignalTiePolarity).optional(),
});
exports.MODEL_TO_TIE_COMPONENT_TYPE = {
    'capacitor.nonpolarized': SignalTieComponentType.Capacitor,
    'capacitor.polarized': SignalTieComponentType.CapacitorPolarized,
    'inductor.standard': SignalTieComponentType.Inductor,
    'resistor.standard': SignalTieComponentType.Resistor,
};
exports.TIE_COMPONENT_TYPE_TO_MODEL = {
    [SignalTieComponentType.Capacitor]: 'capacitor.nonpolarized',
    [SignalTieComponentType.CapacitorPolarized]: 'capacitor.polarized',
    [SignalTieComponentType.Inductor]: 'inductor.standard',
    [SignalTieComponentType.Resistor]: 'resistor.standard',
};
function isPolarizedTieComponentType(componentType) {
    return componentType === SignalTieComponentType.CapacitorPolarized;
}
function reverseSignalTiePolarity(polarity) {
    return polarity === SignalTiePolarity.PositiveOnSignal ?
        SignalTiePolarity.PositiveOnTarget
        : SignalTiePolarity.PositiveOnSignal;
}
exports.TIE_COMPONENT_TYPE_TO_CHARACTERISTIC = {
    [SignalTieComponentType.Capacitor]: sigma_engine_shared_1.BoundaryCharacteristic.Capacitance,
    [SignalTieComponentType.CapacitorPolarized]: sigma_engine_shared_1.BoundaryCharacteristic.Capacitance,
    [SignalTieComponentType.Inductor]: sigma_engine_shared_1.BoundaryCharacteristic.Inductance,
    [SignalTieComponentType.Resistor]: sigma_engine_shared_1.BoundaryCharacteristic.Resistance,
};
exports.TIE_COMPONENT_TYPE_TO_UNITS = {
    [SignalTieComponentType.Capacitor]: sigma_engine_shared_1.CommonParameterUnits.capacitance,
    [SignalTieComponentType.CapacitorPolarized]: sigma_engine_shared_1.CommonParameterUnits.capacitance,
    [SignalTieComponentType.Inductor]: sigma_engine_shared_1.CommonParameterUnits.inductance,
    [SignalTieComponentType.Resistor]: sigma_engine_shared_1.CommonParameterUnits.resistance,
};
//# sourceMappingURL=signal-tie-types.js.map